import { createFileRoute } from "@tanstack/react-router";
import type { SetOpsBenchmarkResult } from "geom/polyclip/test/benchSetOps";
import { runBenchmark } from "geom/polyclip/test/benchSetOps";
import styles from "lib/components/debug/polyclip.module.scss";
import { useState, useEffect } from "react";

function SetOpsBench() {
  const [benchmarkResults, setBenchmarkResults] = useState<any>(undefined);

  useEffect(() => {
    styles;
    setBenchmarkResults(undefined);
    setBenchmarkResults(runBenchmark());
  }, []);

  return (
    <>
      <div
        className={styles.polyclip}
        style={{
          display: "flex",
          fontWeight: "bold",
          flexWrap: "wrap",
          fontSize: 12,
          padding: 10,
        }}
      >
        {benchmarkResults ? (
          <div>
            <h3>Benchmark results</h3>
            <table>
              <tr>
                <th>Test</th>
                <th>polyclip timing (ms)</th>
                <th>polygon-clipping timing (ms)</th>
                <th>Diff</th>
                <th>Fastest</th>
              </tr>
              {benchmarkResults.map((x: SetOpsBenchmarkResult, i: number) => {
                return (
                  <tr key={i}>
                    <td>{x.name}</td>
                    <td>{x.polyclip.toFixed(3)}</td>
                    <td>{x.polygonClipping.toFixed(3)}</td>
                    <td>{x.diff}</td>
                    <td>{x.fastest}</td>
                  </tr>
                );
              })}
            </table>
          </div>
        ) : (
          <h3>Running benchmark...</h3>
        )}
      </div>
    </>
  );
}

export const Route = createFileRoute("/debug/polyclip/set-ops-bench")({
  component: SetOpsBench,
});
